import { Dispatch, FC, useState, useEffect } from "react";
import {
  Box, ButtonProps, FormControl, CardContent, Container, CssBaseline,
  Card, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField,
  ThemeProvider, Typography, createTheme, styled, Select,
  Stack, Alert
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import UserInformation from "../../../types/UserInformation";
import LoadingButton from "@mui/lab/LoadingButton";
import { AlertType } from "../../../types/AlertType";
import { SnackBarAlert } from "../../element/SnackBarAlert";
import {
  profilToAccessCommissionCommercialGRC,
  profilToAccessToAllFonctionnality,
  PROFIL_COUNTRY_MANAGER,
} from "../../../constants/Constants";
import { useDispatch } from "react-redux";
import { loggingUser } from "../../../redux/actions/logginUser";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Chip from "@mui/material/Chip";
import DoneIcon from "@mui/icons-material/Done";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";
import CircularProgress from "@mui/material/CircularProgress";
import SecurityIcon from "@mui/icons-material/Security";
import LockResetIcon from "@mui/icons-material/LockReset";
import OptionalWidthModal from "../../../commons/optional-width-modal/OptionalWidthModal";
import { DataRef } from "../../../types/DataRef";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useStyles } from "../../forms/styles";
import CheckAttr from "../../../utils/CheckAttr";
import MfaEmailModal from "../auth/MfaEmailModal";
import { getDeviceFingerprint } from "../../../utils/deviceFingerprint";

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

const CustomButtonImport = styled(LoadingButton)<ButtonProps>(({ theme }) => ({
  backgroundColor: "#FC8404",
  fontSize: 16,
  textTransform: "none",
  "&:hover": {
    backgroundColor: theme.palette.warning.main,
  },
}));

interface LoginProps {
  setIsLogged: Dispatch<React.SetStateAction<boolean>>;
}

interface UserInfo {
  email: string;
  password: string;
}

interface UserInfoValidation {
  email: boolean;
  password: boolean;
}

const resetUserInfo: UserInfo = {
  email: "",
  password: "",
};

const resetValidation: UserInfoValidation = {
  email: false,
  password: false,
};

const baseUrlApi = process.env.REACT_APP_BASE_API_URL as string;

const Login: FC<LoginProps> = ({ setIsLogged }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingPasswordLess, setLoadingPawordLess] = useState<boolean>(false);
  const [emailSended, setEmailSended] = useState<boolean>(false);
  const [isRedirect, setIsRedirect] = useState<boolean>(false);
  const [openSnack, setOpenSnack] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState(false);

  const [userInfo, setUserinfo] = useState<UserInfo>(resetUserInfo);
  const [userValidation, setUserValidation] = useState<UserInfoValidation>(resetValidation);

  const [alertMessage, setAlerteMessage] = useState<string>("");
  const [pathToRedirect, setPathToRedirect] = useState<string>("/acceuil");
  const [alertType, setAlertType] = useState<AlertType>("success");
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [profilIdSelected, setProfilIdSelected] = useState<number>(0);
  const [allProfilUser, setAllProfilUser] = useState<DataRef[]>([]);
  const [tokenTemp, setTokenTemp] = useState<string>("");

  const [mfaOpen, setMfaOpen] = useState<boolean>(false);
  const [mfaUserId, setMfaUserId] = useState<number>(0);

  const cookies = new Cookies();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // Si Il y a un token
    let tokenToTeste: string = cookies.get("jwt");
    if (tokenToTeste) {
      navigate("/acceuil");
    }
  }, []);

  const http = axios.create({
    withCredentials: true,
    baseURL: baseUrlApi,
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    setUserinfo({
      ...(userInfo as UserInfo),
      [name]: value,
    });
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const RedirectionByProfil = (profils: DataRef, updated_password: boolean) => {
    // 
    if (
      !profilToAccessToAllFonctionnality.includes(profils?.libelle) &&
      !updated_password
    ) {
      setPathToRedirect("/account");
    } else if (profils?.libelle === PROFIL_COUNTRY_MANAGER) {
      setPathToRedirect("/rentabilite");
    }
    else if (profilToAccessCommissionCommercialGRC.includes(profils?.libelle)) {
      setPathToRedirect("/commission");
    }
  }

  const handleClickValider = () => {
    if (CheckAttr(profilIdSelected) && profilIdSelected !== 0) {
      // Apres Choix Profil En Appelle Le User Info By Profil
      http
        .get(`user/info/via-profil/${profilIdSelected}`, {
          headers: {
            Authorization: `Bearer ${tokenTemp}`,
          },
        })
        .then((res) => {
          const {
            id,
            name,
            prenom,
            email,
            Departement,
            pays,
            profils,
            features,
            updated_password,
            password_expired,
            multiProfile,
            allProfil,
          } = res.data as UserInformation;

          const user: UserInformation = {
            id,
            name,
            prenom,
            email,
            Departement,
            pays,
            profils,
            features,
            updated_password,
            password_expired
          };

          cookies.set("jwt", tokenTemp, { path: "/" });
          cookies.set("menu", true, { path: "/" });
          // Profil choisi par l'utilisateur, envoye au back via le header X-Profil-Id
          cookies.set("profil_id", profils?.id ?? profilIdSelected, { path: "/" });

          RedirectionByProfil(profils, updated_password);

          setIsLogged(true);

          setIsRedirect(true);

          dispatch(loggingUser(user));
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setAlerteMessage("SVP! Choisir une Profil!");
      setAlertType("warning");
      setOpenSnack(true);
    }
  };

  const validationInput = (): boolean => {
    setUserValidation(resetValidation);
    if (userInfo?.email.length === 0 || userInfo?.password.length === 0) {
      if (userInfo?.email.length === 0) {
        setUserValidation({ ...userValidation, email: true });
      }

      if (userInfo?.password.length === 0) {
        setUserValidation({ ...userValidation, password: true });
      }

      return false;
    }

    return true;
  };

  const loginSuccess = async (token: string) => {
    await http.get("user/info", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => {
      const { profils, updated_password, multiProfile, allProfil } = res?.data as UserInformation;

      if (multiProfile) {
        setAllProfilUser(allProfil as DataRef[]);
        setOpenModal(true);
      } else {
        cookies.set("jwt", token, { path: "/" });
        cookies.set("menu", true, { path: "/" });
        // Mono-profil : le seul profil de l'utilisateur
        cookies.set("profil_id", profils?.id, { path: "/" });

        RedirectionByProfil(profils, updated_password);

        setIsLogged(true);

        setIsRedirect(true);

        dispatch(loggingUser(res?.data as UserInformation));
      }
    }).catch((error) => {
      console.log(error);
    }).finally(() => {
      setLoading(false);
    });
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (validationInput()) {
      setLoading(true);

      const fingerprint = await getDeviceFingerprint();

      await http.post("user/login", {
        ...userInfo,
        device_fingerprint: fingerprint,
      }).then((res) => {
        setTokenTemp(res?.data?.token);

        if (res?.data?.mfa_required) {
          setMfaUserId(res?.data?.user_id);
          setMfaOpen(true);
          setLoading(false);
          return;
        }

        loginSuccess(res?.data?.token);
      }).catch((error) => {
        const messageDuBack = error?.response?.data?.message;
        setAlerteMessage(
          messageDuBack
        );

        setAlertType("warning");
        setOpenSnack(true);

        console.log(error);
        setLoading(false);
      });
    }
  };

  const handleClickMDPOublie = () => {
    if (userInfo?.email.length === 0) {
      setUserValidation({ ...userValidation, email: true });
      setAlerteMessage("merci de renseigner votre email SVP");
      setAlertType("warning");
      setOpenSnack(true);
    } else {
      setLoadingPawordLess(true);
      setUserValidation({ ...userValidation, email: false });

      const data = {
        email: userInfo?.email,
      };

      http.post("user/emailrestoremdp", data)
        .then(() => {
          setAlerteMessage(
            "Un e-mail vous a été envoyé pour la modification de votre mot de passe"
          );
          setAlertType("success");
          setOpenSnack(true);
          setEmailSended(true);
        })
        .catch((error) => {
          setAlerteMessage("Cette Email n'existe pas dans SuiviRenta");
          setAlertType("warning");
          setOpenSnack(true);
        })
        .finally(() => {
          setLoadingPawordLess(false);
        });
    }
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setShowPassword(!showPassword);
  };

  const handleCloseAlert = () => {
    setOpenSnack(false);
  };

  const stackAlert: JSX.Element = SnackBarAlert(
    openSnack,
    handleCloseAlert,
    alertType,
    alertMessage
  );

  if (isRedirect) {
    navigate(pathToRedirect);
  }

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <Card sx={{ minWidth: 275 }}>
          <CardContent>
            <CssBaseline />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                src="images/logo_dark.png"
                width={200}
                height={59}
                alt="Logo outsourcia"
              />
              <Typography
                component="h5"
                variant="h5"
                align="left"
                color="GrayText"
                mt={5}
              >
                Se connecter
              </Typography>
              <Box component="form" onSubmit={handleSubmit} noValidate>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Adresse email"
                  color="warning"
                  error={userValidation.email}
                  value={userInfo?.email}
                  name="email"
                  autoComplete="on"
                  autoFocus
                  onChange={handleChange}
                />
                <FormControl variant="outlined" sx={{ width: "100%", my: 2 }}>
                  <InputLabel
                    htmlFor="outlined-adornment-password"
                    color="warning"
                  >
                    Mot de passe
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    name="password"
                    label="Mot de passe"
                    color="warning"
                    fullWidth
                    type={showPassword ? "text" : "password"}
                    value={userInfo?.password}
                    error={userValidation.password}
                    onChange={handleChange}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(!showPassword)}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>

                <Chip
                  label="Mot de passe oublié ?"
                  variant="filled"
                  size="small"
                  onClick={handleClickMDPOublie}
                  color="warning"
                  style={{ backgroundColor: "#FC8404" }}
                  icon={
                    loadingPasswordLess ? (
                      <CircularProgress size={12} />
                    ) : emailSended ? (
                      <DoneIcon />
                    ) : (
                      <AttachEmailIcon />
                    )
                  }
                />

                <CustomButtonImport
                  type="submit"
                  fullWidth
                  variant="contained"
                  loading={loading}
                  sx={{ mt: 3, mb: 2 }}
                >
                  Connexion
                </CustomButtonImport>
              </Box>
            </Box>

            <Stack spacing={2} my={2}>
              <Alert
                severity="warning"
                icon={<SecurityIcon />}
                sx={{ fontSize: "0.85rem" }}
              >
                Après <strong>5 tentatives de connexion infructueuses</strong>,
                votre compte sera automatiquement <strong>désactivé</strong>.
              </Alert>

              <Alert
                severity="info"
                icon={<LockResetIcon />}
                sx={{ fontSize: "0.85rem" }}
              >
                Pour des raisons de sécurité, un
                <strong> changement de mot de passe est requis tous les 6 mois</strong>.
              </Alert>
            </Stack>
          </CardContent>
        </Card>
      </Container>

      <OptionalWidthModal
        title="Profil"
        onClose={handleClose}
        open={openModal}
        breackPoint="xs"
      >
        <FormControl
          variant="outlined"
          className={classes.formControl}
          sx={{ marginLeft: 1, marginTop: 1 }}
        >
          <InputLabel htmlFor="profil_user_id" color="warning" shrink={true}>
            Profil utilisateur
          </InputLabel>
          <Select
            id="profil_user_id"
            native
            color="warning"
            value={profilIdSelected}
            error={profilIdSelected === 0}
            onChange={(e) => {
              setProfilIdSelected(e.target.value as number);
            }}
            label="Profil utilisateur"
            inputProps={{
              name: "profil_user_id",
            }}
          >
            <option value=""></option>
            {allProfilUser?.map((profil) => (
              <option key={profil?.id} value={profil?.id}>
                {profil?.libelle}
              </option>
            ))}
          </Select>
        </FormControl>
        <Box display="flex" justifyContent="center" mt={5}>
          <LoadingButton
            onClick={() => handleClickValider()}
            endIcon={<CheckCircleOutlineIcon />}
            loading={loading}
            loadingPosition="end"
            sx={{ textTransform: "none" }}
            variant="contained"
            color="warning"
          >
            Valider
          </LoadingButton>
        </Box>
      </OptionalWidthModal>

      <MfaEmailModal
        open={mfaOpen}
        userId={mfaUserId}
        onClose={() => setMfaOpen(false)}
        onSuccess={(tokenTemp) => {
          setMfaOpen(false);
          loginSuccess(tokenTemp);
        }}
      />

      {stackAlert}
    </ThemeProvider>
  );
};

export default Login;
